import Vue from 'vue'
import Vuex from 'vuex'
import { getLoc, setLoc } from '@/utils'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    setting: getLoc({ key: 'setting', json: 1 }) || {}
  },
  mutations: {
    SET_SETTING: (state, val) => {
      state.setting = val
      setLoc({ key: 'setting', value: val })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js